const NODE_PROD = 'production'
const SPRING_PROD = 'prod'
const SPRING_DEV = 'dev'

function profilesAtivos(): string[] {
  return (process.env.REACT_APP_SPRING_PROFILES_ACTIVE ?? '').split(',')
}

export function isProd(): boolean {
  return process.env.NODE_ENV === NODE_PROD && profilesAtivos().includes(SPRING_PROD)
}

export function isMetricsProd(): boolean {
  return process.env.NODE_ENV === NODE_PROD && !profilesAtivos().includes(SPRING_DEV)
}
